@let loading = (loading$ | async) || false;
@let blankStep = (blankStep$ | async) || false;
@let pfStep = (pfStep$ | async) || false;
@let isAppliedEpic = (isAppliedEpic$ | async) || false;
@let stripeStep = (stripeStep$ | async) || false;
@let scheduleStep = (scheduleStep$ | async) || false;
@let stripeFinal = (stripeFinal$ | async) || false;
@let receiptStep = (receiptStep$ | async) || false;
@let paymentLinkCompleted = (paymentLinkCompleted$ | async) || false;
@let paymentLinkCancelled = (paymentLinkCancelled$ | async) || false;
@let dialogOpened = (dialogOpened$ | async) || environment.standalone;
@let canFinalizePayment = (canFinalizePayment$ | async) || false;
@let showSpeedbump = (showSpeedbump$ | async) || false;
@let showVerifyPin = (showVerifyPin$ | async) || false;
@let acssSupported = (acssSupported$ | async) || false;

<div class="example-wrapper" #rootElement>
  <kendo-dialog *ngIf="dialogOpened" (close)="cancel()" width="100%">
    <kendo-dialog-titlebar *ngIf="!receiptStep && !paymentLinkCompleted && !paymentLinkCancelled">
      <div class="container-fluid">
        <div class="row">
          <img
            class="align-self-center logo"
            src="data:image/png;base64, {{ session?.merchant?.logo }}"
            alt="{{ session?.merchant?.name?.company }}"
          />
        </div>
      </div>
    </kendo-dialog-titlebar>
    <!-- PPD-1321: Applied Epic broker preview — copy payment URL bar -->
    <div *ngIf="isAppliedEpic" class="epic-preview-bar">
      <div class="epic-preview-content">
        <span class="epic-preview-label">Payment preview — copy link to share with client:</span>
        <button
          type="button"
          class="button-secondary"
          style="max-width: 300px"
          (click)="copyUrl()"
        >{{ copyText }}</button>
      </div>
    </div>

    <div class="container-fluid subtitle" *ngIf="!receiptStep && !paymentLinkCompleted && !paymentLinkCancelled">
      <div class="row">
        <div
          class="column d-flex justify-content-between d-lg-none"
          *ngIf="getAmountCents() > 0"
        >
          <h2 class="subtitle-text">Total</h2>
          <h2 class="subtitle-text" *ngIf="stripeFinal">{{ getStripeTotal() }}</h2>
          <h2 class="subtitle-text" *ngIf="!stripeFinal">{{ getAmount() }}</h2>
        </div>

        <div class="column d-none d-lg-block">
          <h2 class="subtitle-text">{{ getString("paymentTitle") }}</h2>

          <!--          <div style="position: absolute; right: 32px; top: 16px">-->
          <!--            <button-->
          <!--              class="k-button-clear e2e-clear"-->
          <!--              [class.selected]="currentLanguage === 'en'"-->
          <!--              (click)="setLanguage('en')"-->
          <!--              [disabled]="loading"-->
          <!--            >-->
          <!--              EN-->
          <!--            </button>-->
          <!--            <button-->
          <!--              class="k-button-clear e2e-clear"-->
          <!--              [class.selected]="currentLanguage === 'fr'"-->
          <!--              (click)="setLanguage('fr')"-->
          <!--              [disabled]="loading"-->
          <!--            >-->
          <!--              FR-->
          <!--            </button>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
    <div class="container-lg main">
      <div class="row main-row" *ngIf="!receiptStep && !paymentLinkCompleted && !paymentLinkCancelled">
        <div class="col-12 col-lg-8">
          <div class="row section" *ngIf="isBlank">
            <div class="col-12 d-flex">
              <div class="align-self-center">
                <kendo-svg-icon
                  [icon]="icons.moneyIcon"
                  size="xlarge"
                  themeColor="primary"
                  style="width: 24px"
                ></kendo-svg-icon>
              </div>

              <div class="section-header-container">
                <h3 class="section-header">1. Enter amount to pay</h3>
              </div>
              <div class="flex-grow-1"></div>
              <div class="edit-button-container" *ngIf="!blankStep">
                <button
                  kendoButton
                  themeColor="secondary"
                  fillMode="link"
                  (click)="showEditAmount($event)"
                  [disabled]="loading"
                >
                  <kendo-loader
                    *ngIf="loading"
                    type="infinite-spinner"
                    size="small"
                    themeColor="dark"
                    class="edit-loader"
                  />
                  Edit
                </button>
              </div>
            </div>
            <form
              [formGroup]="amountForm"
              (ngSubmit)="submitAmount($event)"
              [ngClass]="{ collapsed: !blankStep }"
              class="col-12"
            >
              <div
                class="row client-details-container"
                style="padding-bottom: 23px"
              >
                <div class="col-md-8">
                  <kendo-formfield>
                    <kendo-label text="Enter amount">
                      <kendo-numerictextbox
                        format="c"
                        [required]="true"
                        formControlName="amount"
                      />
                    </kendo-label>

                    <kendo-formerror>
                      {{ getString("formRequired", "Amount") }}
                    </kendo-formerror>
                  </kendo-formfield>
                </div>
                <div class="col-md-4 d-flex" style="padding: 28px 0 0 0">
                  <button
                    kendoButton
                    size="large"
                    themeColor="primary"
                    class="flex-grow-1"
                    type="submit"
                    [disabled]="loading || this.amountForm.invalid"
                  >
                    <kendo-loader
                      *ngIf="loading"
                      type="infinite-spinner"
                      size="small"
                      themeColor="light"
                    />
                    Save amount
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="row section">
            <div class="col-12 d-flex">
              <div class="align-self-center">
                <kendo-svg-icon
                  [icon]="icons.userIcon"
                  size="xlarge"
                  themeColor="primary"
                ></kendo-svg-icon>
              </div>

              <div class="section-header-container">
                <h3 class="section-header" *ngIf="isBlank">
                  2. Client details
                </h3>
                <h3 class="section-header" *ngIf="!isBlank">
                  1. Client details
                </h3>
              </div>
              <div class="flex-grow-1"></div>
              <div class="edit-button-container" *ngIf="stripeStep || scheduleStep || pfStep">
                <button
                  kendoButton
                  themeColor="secondary"
                  fillMode="link"
                  (click)="showClient($event)"
                  [disabled]="loading || !this.amountForm.valid"
                >
                  <kendo-loader
                    *ngIf="loading"
                    type="infinite-spinner"
                    size="small"
                    themeColor="dark"
                    class="edit-loader"
                  />
                  Edit
                </button>
              </div>
            </div>
            <form
              [formGroup]="form"
              (ngSubmit)="proceedFromClientDetails()"
              [ngClass]="{ collapsed: stripeStep || blankStep || scheduleStep || pfStep }"
              class="col-12"
            >
              <div class="row client-details-container">
                <div class="col-md-6" *ngIf="policyId?.show">
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="policyIdFieldConfig"
                    fieldName="policyId"
                    formControlName="policyId"
                  ></app-input-field>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="shouldDisplayClientInfo('customerId')"
                >
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="getFieldConfig('customerId')"
                    fieldName="customerId"
                    formControlName="customerId"
                  ></app-input-field>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="shouldDisplayClientInfo('firstName')"
                >
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="getFieldConfig('firstName')"
                    fieldName="firstName"
                    formControlName="firstName"
                  ></app-input-field>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="shouldDisplayClientInfo('lastName')"
                >
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="getFieldConfig('lastName')"
                    fieldName="lastName"
                    formControlName="lastName"
                  ></app-input-field>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="shouldDisplayClientInfo('insuredName')"
                >
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="getFieldConfig('insuredName')"
                    fieldName="insuredName"
                    formControlName="insuredName"
                  ></app-input-field>
                </div>
                <div class="col-md-6" *ngIf="shouldDisplayClientInfo('email')">
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="getFieldConfig('email')"
                    fieldName="email"
                    formControlName="email"
                  ></app-input-field>
                </div>
                <div class="col-12" *ngIf="shouldDisplayClientInfo('address')">
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="getFieldConfig('address')"
                    fieldName="address"
                    formControlName="address"
                  ></app-input-field>
                </div>
                <div class="w-100 p-0 m-0"></div>
                <div class="col-md-4" *ngIf="shouldDisplayClientInfo('city')">
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="getFieldConfig('city')"
                    fieldName="city"
                    formControlName="city"
                  ></app-input-field>
                </div>
                <div
                  class="col-md-4"
                  *ngIf="shouldDisplayClientInfo('province')"
                >
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="getFieldConfig('province')"
                    fieldName="province"
                    formControlName="province"
                  ></app-input-field>
                </div>
                <div class="col-md-4" *ngIf="shouldDisplayClientInfo('zip')">
                  <app-input-field
                    [handleTranslate]="translate"
                    [handleTextBlur]="onTextBlur"
                    [fieldConfig]="getFieldConfig('zip')"
                    fieldName="zip"
                    formControlName="zip"
                  ></app-input-field>
                </div>
                <div class="col-md-4" *ngIf="acssSupported">
                  <kendo-formfield>
                    <kendo-label text="Account type" />
                    <select formControlName="acssAccountType" class="dropdown">
                      <option value="business">Business</option>
                      <option value="personal">Personal</option>
                    </select>
                    <kendo-formerror>
                      {{ getString("formRequired", "Account type") }}
                    </kendo-formerror>
                  </kendo-formfield>
                </div>
              </div>
              <div class="row section-action client-details-container">
                <div class="col-lg-8 d-none d-lg-block"></div>
                <div class="col-lg-4 d-flex">
                  <button
                    kendoButton
                    size="large"
                    themeColor="primary"
                    class="flex-grow-1"
                    type="submit"
                    [disabled]="loading || !this.form.valid"
                  >
                    <kendo-loader
                      *ngIf="loading"
                      type="infinite-spinner"
                      size="small"
                      themeColor="light"
                    />
                    Save details
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="row section payment-schedule-section" *ngIf="showScheduleStep()">
            <div class="col-12 d-flex">
              <div class="align-self-center">
                <kendo-svg-icon
                  [icon]="icons.calendarIcon"
                  size="xlarge"
                  themeColor="primary"
                ></kendo-svg-icon>
              </div>
              <div class="section-header-container">
                <h3 class="section-header">
                  {{ scheduleSectionNumber() }}. {{ getString("paymentScheduleHeader") }}
                </h3>
              </div>
              <div class="flex-grow-1"></div>
              <div class="edit-button-container" *ngIf="stripeStep || stripeFinal || pfStep">
                <button
                  kendoButton
                  themeColor="secondary"
                  fillMode="link"
                  (click)="showSchedule($event)"
                  [disabled]="loading"
                >
                  <kendo-loader
                    *ngIf="loading"
                    type="infinite-spinner"
                    size="small"
                    themeColor="dark"
                    class="edit-loader"
                  />
                  Edit
                </button>
              </div>
            </div>
            <form
              (submit)="proceedFromSchedule($event)"
              [ngClass]="{ collapsed: !scheduleStep }"
              class="col-12"
            >
              <div class="row client-details-container">
                <div class="col-md-8">
                  <kendo-formfield>
                    <kendo-label
                      [for]="scheduleSelect"
                      text="{{ getString('paymentScheduleChooseLabel') }}"
                    ></kendo-label>
                    <select
                      #scheduleSelect
                      id="paymentScheduleRuleId"
                      class="dropdown"
                      [value]="selectedPaymentScheduleRuleId ?? ''"
                      (change)="onPaymentScheduleChange(scheduleSelect.value === '' ? null : scheduleSelect.value)"
                    >
                      <option *ngFor="let opt of paymentScheduleOptions" [value]="opt.id ?? ''">
                        {{ opt.id === null ? getString("paymentScheduleInFullOption") : opt.name }}
                      </option>
                    </select>
                    <kendo-loader
                      *ngIf="(paymentScheduleLoading$ | async)"
                      type="infinite-spinner"
                      size="small"
                      themeColor="dark"
                      aria-label="Loading payment plans"
                    ></kendo-loader>
                  </kendo-formfield>
                </div>
              </div>
              <!-- PPD-629 — calendar shown only for "Schedule payment in full",
                   bounded by the merchant's configured window. -->
              <div
                class="row payment-schedule-date"
                *ngIf="selectedPaymentScheduleRuleId === SCHEDULE_FULL_ID"
              >
                <div class="col-md-8">
                  <kendo-formfield>
                    <kendo-label
                      [for]="scheduleDate"
                      text="{{ getString('scheduleDateLabel') }}"
                    ></kendo-label>
                    <!-- Native date input: the browser renders its own calendar, which
                         works inside this ShadowDom component (Kendo's popup does not). -->
                    <input
                      #scheduleDate
                      type="date"
                      id="scheduledPaymentDate"
                      class="dropdown"
                      [min]="scheduleMinDate"
                      [max]="scheduleMaxDate"
                      [value]="scheduledPaymentDate"
                      (change)="onScheduledDateChange($event)"
                    />
                  </kendo-formfield>
                </div>
              </div>
              <div
                class="row payment-schedule-preview"
                *ngIf="paymentSchedulePreview.length > 0"
              >
                <div class="col-md-8">
                  <div class="payment-schedule-preview-card">
                    <div class="payment-schedule-preview-header">
                      {{ getString("paymentScheduleSubHeader") }}
                    </div>
                    <table class="payment-schedule-preview-table">
                      <thead>
                        <tr>
                          <th>{{ getString("paymentScheduleColPayment") }}</th>
                          <th>{{ getString("paymentScheduleColDueDate") }}</th>
                          <th class="amount">{{ getString("paymentScheduleColAmount") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let row of paymentSchedulePreview">
                          <td>{{ getString("paymentSchedulePaymentLabel", row.number.toString()) }}</td>
                          <td>{{ row.dueDate | date:'y-MM-dd' }}</td>
                          <td class="amount">{{ toCurrency(row.amountCents / 100) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row section-action client-details-container">
                <div class="col-lg-8 d-none d-lg-block"></div>
                <div class="col-lg-4 d-flex">
                  <button
                    kendoButton
                    size="large"
                    themeColor="primary"
                    class="flex-grow-1"
                    type="submit"
                    [disabled]="loading"
                  >
                    <kendo-loader
                      *ngIf="loading"
                      type="infinite-spinner"
                      size="small"
                      themeColor="light"
                    />
                    Next
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="row section">
            <div class="col-12 d-flex">
              <div class="align-self-center">
                <kendo-svg-icon
                  [icon]="icons.walletIcon"
                  size="xlarge"
                  themeColor="primary"
                ></kendo-svg-icon>
              </div>

              <div class="section-header-container">
                <h3 class="section-header">
                  {{ paymentMethodSectionNumber() }}. Payment method
                </h3>
              </div>
              <div class="flex-grow-1"></div>
              <div class="edit-button-container" *ngIf="stripeFinal">
                <button
                  kendoButton
                  themeColor="secondary"
                  fillMode="link"
                  (click)="showPaymentMethod($event)"
                  [disabled]="loading"
                >
                  <kendo-loader
                    *ngIf="loading"
                    type="infinite-spinner"
                    size="small"
                    themeColor="dark"
                    class="edit-loader"
                  />
                  Edit
                </button>
              </div>
            </div>
            <div class="col-12">
              <!-- PPD-1300 — payment method type selector and premium finance offer card.
                   Shown only when this RTP link has a valid PF quote (available = true). -->
              <div [ngClass]="{ collapsed: !pfStep }" class="pf-selection-container">
                <div class="row client-details-container">
                  <div class="col-md-8">
                    <kendo-formfield>
                      <kendo-label text="Payment option"></kendo-label>
                      <select
                        class="dropdown"
                        [value]="selectedPaymentMethodType"
                        (change)="onPaymentMethodTypeChange($any($event.target).value)"
                      >
                        <option value="stripe">Standard Payment</option>
                        <option value="premiumFinance">Premium Finance</option>
                      </select>
                    </kendo-formfield>
                  </div>
                </div>

                <!-- Premium Finance offer card -->
                <div
                  class="row client-details-container pf-card-row"
                  *ngIf="selectedPaymentMethodType === 'premiumFinance' && premiumFinanceQuote"
                >
                  <div class="col-md-8">
                    <div class="pf-offer-card">
                      <div class="pf-offer-card-header">Premium Finance Details</div>
                      <table class="pf-offer-card-table">
                        <tbody>
                          <tr>
                            <td class="pf-label">Carrier</td>
                            <td class="pf-value">{{ premiumFinanceQuote.carrier }}</td>
                          </tr>
                          <tr>
                            <td class="pf-label">Coverage Code</td>
                            <td class="pf-value">{{ premiumFinanceQuote.coverageCode }}</td>
                          </tr>
                          <tr>
                            <td class="pf-label">Agency Code</td>
                            <td class="pf-value">{{ premiumFinanceQuote.agencyCode }}</td>
                          </tr>
                          <tr>
                            <td class="pf-label">Payment Term</td>
                            <td class="pf-value">{{ premiumFinanceQuote.paymentTerm }}</td>
                          </tr>
                          <tr class="pf-divider-row">
                            <td colspan="2"><hr class="pf-divider" /></td>
                          </tr>
                          <tr>
                            <td class="pf-label">Down Payment</td>
                            <td class="pf-value pf-amount">{{ toCurrency(premiumFinanceQuote.downPayment ?? 0) }}</td>
                          </tr>
                          <tr>
                            <td class="pf-label">Number of Installments</td>
                            <td class="pf-value">{{ premiumFinanceQuote.numberOfInstallments }}</td>
                          </tr>
                          <tr>
                            <td class="pf-label">Installment Amount</td>
                            <td class="pf-value pf-amount">{{ toCurrency(premiumFinanceQuote.installmentAmount ?? 0) }}</td>
                          </tr>
                          <tr>
                            <td class="pf-label">APR</td>
                            <td class="pf-value">{{ premiumFinanceQuote.apr }}%</td>
                          </tr>
                          <tr>
                            <td class="pf-label">Total of Payments</td>
                            <td class="pf-value pf-amount">{{ toCurrency(premiumFinanceQuote.totalOfPayments ?? 0) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <!-- "Next" button — only shown when Standard Payment is selected;
                     creates the Stripe customer session and collapses this step. -->
                <div
                  class="row section-action client-details-container"
                  *ngIf="selectedPaymentMethodType === 'stripe'"
                >
                  <div class="col-lg-8 d-none d-lg-block"></div>
                  <div class="col-lg-4 d-flex">
                    <button
                      kendoButton
                      size="large"
                      themeColor="primary"
                      class="flex-grow-1"
                      type="button"
                      [disabled]="loading"
                      (click)="proceedFromPfSelection()"
                    >
                      <kendo-loader
                        *ngIf="loading"
                        type="infinite-spinner"
                        size="small"
                        themeColor="light"
                      />
                      Next
                    </button>
                  </div>
                </div>
              </div>

              <form
                (submit)="stripeSubmit($event)"
                [ngClass]="{ collapsed: !stripeStep || stripeFinal }"
              >
                <div class="row client-details-container">
                  <div class="col-12">
                    <slot name="stripe-container"></slot>
                  </div>
                </div>
                <div class="row section-action client-details-container">
                  <div class="col-lg-8 d-none d-lg-block"></div>
                  <div class="col-lg-4 d-flex">
                    <button
                      kendoButton
                      size="large"
                      themeColor="primary"
                      class="flex-grow-1"
                      type="submit"
                      [disabled]="loading"
                    >
                      <kendo-loader
                        *ngIf="loading"
                        type="infinite-spinner"
                        size="small"
                        themeColor="light"
                      />
                      Next
                    </button>
                  </div>
                </div>
              </form>
              <div
                [ngClass]="{ collapsed: !stripeFinal }"
                class="payment-method-container"
              >
                <hr />
                <p class="payment-method">
                  {{ brand }} Ending in {{ identifier }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4 d-flex flex-column summary">
          <div class="row">
            <div class="col">
              <h3 class="summary-header">
                {{ summarySectionNumber() }}. Payment Summary
              </h3>
            </div>
          </div>
          <div class="row totals">
            <div class="col">
              <div class="d-flex justify-content-between border-bottom">
                <div>
                  <p>Invoice amount</p>
                </div>
                <div>
                  <p>{{ getAmount() }}</p>
                </div>
              </div>
              <div
                class="d-flex justify-content-between border-bottom"
                *ngIf="isOtfApplicable()"
              >
                <div>
                  <p>{{ getOneTimeFeeName() }}</p>
                </div>
                <div>
                  <p>{{ getOneTimeFee() }}</p>
                </div>
              </div>
              <div
                class="d-flex justify-content-between border-bottom"
                *ngIf="!(pfStep && selectedPaymentMethodType === 'premiumFinance')"
              >
                <div
                  iptooltipcontainer
                >
                  <p>
                    Service fee
                    <kendo-svg-icon
                      [icon]="icons.tooltipIcon"
                      class="tooltip-icon"
                      id="iptooltipaction"
                      *ngIf="stripeFee > 0"
                    ></kendo-svg-icon>
                    <app-tooltip selector="#iptooltipaction" *ngIf="stripeFee > 0" >{{ translate(session?.merchant?.paymentLabel?.fee?.tooltip) }}</app-tooltip>
                  </p>
                </div>
                <div>
                  <p *ngIf="stripeFinal">{{ getStripeFee() }}</p>
                  <p *ngIf="!stripeFinal">To be calculated</p>
                </div>
              </div>
              <div
                class="d-flex justify-content-between"
                *ngIf="!(pfStep && selectedPaymentMethodType === 'premiumFinance')"
              >
                <div>
                  <p>Estimated total</p>
                </div>
                <div>
                  <p *ngIf="stripeFinal" class="total">{{ getPreSubmitStripeTotalWithOtf() }}</p>
                  <p *ngIf="!stripeFinal">{{ getPreSubmitEstimatedTotal() }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- PPD-1300 — when Premium Finance is selected, the standard Pay now flow
               does not apply; show an informational note instead. -->
          <ng-container *ngIf="pfStep && selectedPaymentMethodType === 'premiumFinance'; else payNowForm">
            <div class="row pay-section">
              <div class="col">
                <p class="pf-contact-note">
                  To proceed with premium financing, please contact your agent or broker.
                </p>
              </div>
            </div>
          </ng-container>
          <ng-template #payNowForm>
          <form (submit)="submitAgreement($event)">
            <div class="row pay-section">
              <div class="col d-flex">
                <div class="k-form-field-checkbox-wrap d-flex">
                  <kendo-checkbox
                    (checkedStateChange)="agreementChecked($event)"
                    #agreement
                  ></kendo-checkbox>
                  <kendo-label
                    [for]="agreement"
                    class="k-checkbox-label"
                    [innerHTML]="translate(disclaimer)"
                  ></kendo-label>
                </div>
              </div>
            </div>
            <div
              class="row pay-section"
              *ngIf="stripeFee > 0 && isBifurcated"
            >
              <div class="col d-flex">
                <div class="k-form-field-checkbox-wrap d-flex">
                  <kendo-checkbox
                    (checkedStateChange)="bifurcationAgreementChecked($event)"
                    #bifurcationAgreement
                  ></kendo-checkbox>
                  <kendo-label
                    [for]="bifurcationAgreement"
                    class="k-checkbox-label"
                    [innerHTML]="translate(bifurcationDisclaimer)"
                  ></kendo-label>
                </div>
              </div>
            </div>
            <div class="row pay-section" *ngIf="isBlank">
              <div class="col d-flex justify-content-center">
                <slot name="recaptcha-container"></slot>
              </div>
            </div>
            <div class="row pay-section">
              <div class="col d-flex">
                <button
                  kendoButton
                  [disabled]="!canFinalizePayment || loading"
                  themeColor="primary"
                  size="large"
                  class="flex-grow-1"
                  type="submit"
                >
                  <kendo-loader
                    *ngIf="loading"
                    type="infinite-spinner"
                    size="small"
                    themeColor="light"
                  />
                  Pay now
                </button>
              </div>
            </div>
          </form>
          </ng-template>
          <div class="row flex-grow-1"></div>
          <div class="row logo-section">
            <div class="col justify-content-around d-flex">
              <img
                src="{{ logo }}"
                alt="insurepay payments logo"
                class="ip-logo"
              />
            </div>
          </div>
        </div>
      </div>
      <kendo-pdf-export #pdf paperSize="A4" margin="0.5cm" [scale]="0.6">
        <div class="row main-row" *ngIf="receiptStep">
          <div class="col-12 receipt">
            <!-- PPD-629 — scheduled payment: no charge at checkout, so show a
                 simple confirmation instead of the charge receipt. -->
            <div class="scheduled-confirmation" *ngIf="isScheduledPayment">
              <div class="scheduled-check">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M5 13l4 4L19 7"></path>
                </svg>
              </div>
              <h1>Thank you!</h1>
              <p>Your payment has been scheduled.</p>
            </div>

            <ng-container *ngIf="!isScheduledPayment">
            <div class="d-flex justify-content-between">
              <img
                class="align-self-center logo receipt-logo"
                src="data:image/png;base64, {{ session?.merchant?.logo }}"
                alt="{{ session?.merchant?.name?.company }}"
              />
              <button
                kendoButton
                size="large"
                themeColor="primary"
                type="button"
                class="download-receipt-top-button"
                (click)="pdf.saveAs('receipt.pdf')"
              >
                Download receipt
              </button>
            </div>

            <hr />

            <h1>Thank you for your payment!</h1>

            <p *ngIf="form?.value?.firstName" class="hello-line">
              Hello {{ form.value.firstName }},
            </p>

            <p>
              Your
              <b>{{ paymentType === "card" ? "Credit Card" : paymentType == "us_bank_account" ? "ACH" : "EFT" }}</b>
              payment for {{ session?.merchant?.name?.company }}
              {{ paymentType === "us_bank_account" || paymentType === "acss_debit" ? "is being processed." : "has been processed successfully." }}
            </p>

            <hr />

            <div class="receipt-upper">
              <ng-container *ngFor="let field of Object.entries(form.value)">
                <div
                  *ngIf="
                    (field[0] === 'firstName' ||
                    field[0] === 'lastName' ||
                    field[0] === 'insuredName' ||
                    field[0] === 'email' ||
                    field[0] === 'address' ||
                    field[0] === 'city' ||
                    field[0] === 'province' ||
                    field[0] === 'zip' ||
                    field[0] === 'customerId') &&
                    getFieldConfig(field[0])?.show
                  "
                >
                  <p class="receipt-title">
                    {{ translate(getFieldConfig(field[0])) }}:
                  </p>
                  <p class="receipt-body">{{ field[1] }}</p>
                </div>
                <div *ngIf="field[0] === 'policyId' && policyId?.show">
                  <p class="receipt-title">{{translate(policyId)}}</p>
                  <p class="receipt-body">{{ field[1] }}</p>
                </div>
              </ng-container>
            </div>

            <hr />

            <div>
              <p class="receipt-title">Transaction ID:</p>
              <p class="receipt-body">{{ transactionId }}</p>
            </div>

            <div>
              <p class="receipt-title">Date:</p>
              <p class="receipt-body">{{ transactionDate }}</p>
            </div>

            <div>
              <p class="receipt-title">Payment method:</p>
              <p class="receipt-body">{{ brand }} ending in {{ identifier }}</p>
            </div>

            <div>
              <p class="receipt-title">Paid to:</p>
              <p class="receipt-body">{{ session?.merchant?.name?.company }}</p>
            </div>

            <div>
              <p class="receipt-title" *ngIf="session?.merchant?.location">
                Company address:
              </p>
              <p class="receipt-body">
                {{ session?.merchant?.location?.address }},
                {{ session?.merchant?.location?.city }},
                {{ session?.merchant?.location?.region }}
              </p>
            </div>

            <div>
              <p class="receipt-title" *ngIf="session?.merchant?.phone?.work">
                Company phone:
              </p>
              <p class="receipt-body">{{ session?.merchant?.phone?.work }}</p>
            </div>

            <hr />

            <div class="d-flex justify-content-between">
              <p class="receipt-title">Premium Paid</p>
              <p>{{ getBaseAmount() }}</p>
            </div>
            <hr class="amount" *ngIf="isOtfApplicable()" />
            <div class="d-flex justify-content-between" *ngIf="isOtfApplicable()">
              <p class="receipt-title">{{ getOneTimeFeeName() }} <span style="font-size:0.82em;color:#777;">(non-refundable)</span></p>
              <p>{{ getOneTimeFee() }}</p>
            </div>
            <hr class="amount" *ngIf="stripeFee > 0" />
            <div class="d-flex justify-content-between" *ngIf="stripeFee > 0">
              <p class="receipt-title">System Access Fees</p>
              <p>{{ getStripeFee() }}</p>
            </div>
            <hr class="amount" />
            <div class="d-flex justify-content-between">
              <p style="font-weight: 700">Total Amount Paid</p>
              <p style="font-weight: 700">{{ getStripeTotal() }}</p>
            </div>

            <p class="receipt-disclaimer" *ngIf="stripeFee > 0 && (isBifurcated || paymentType === 'us_bank_account' || paymentType === 'acss_debit')">
              Note: The system access fee is collected by InsurePay.
            </p>

            <div
              class="receipt-schedule"
              *ngIf="paymentSchedulePreview.length > 0"
            >
              <hr />
              <h3 class="receipt-schedule-title">
                {{ getString("paymentScheduleHeader") }}
              </h3>
              <table class="receipt-schedule-table">
                <thead>
                  <tr>
                    <th>{{ getString("paymentScheduleColPayment") }}</th>
                    <th>{{ getString("paymentScheduleColDueDate") }}</th>
                    <th class="amount">{{ getString("paymentScheduleColAmount") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of paymentSchedulePreview">
                    <td>{{ getString("paymentSchedulePaymentLabel", row.number.toString()) }}</td>
                    <td>{{ row.dueDate | date:'y-MM-dd' }}</td>
                    <td class="amount">{{ toCurrency(row.amountCents / 100) }}</td>
                  </tr>
                </tbody>
              </table>
              <p class="receipt-schedule-disclaimer">
                {{ getString("paymentScheduleFeeChangeNote") }}
              </p>
            </div>

            <hr class="bottom-receipt-break" />

            <div class="download-receipt-bottom-button">
              <button
                kendoButton
                size="large"
                themeColor="primary"
                class="flex-grow-1"
                type="button"
                (click)="pdf.saveAs('receipt.pdf')"
              >
                Download receipt
              </button>
            </div>
            </ng-container>
          </div>
        </div>
      </kendo-pdf-export>
      <div class="row main-row" *ngIf="paymentLinkCompleted">
        <div class="col-12 receipt">
          <div class="scheduled-confirmation">
            <div class="scheduled-check">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <h1>Payment Completed</h1>
            <p>This payment has been completed.</p>
          </div>
        </div>
      </div>
      <div class="row main-row" *ngIf="paymentLinkCancelled">
        <div class="col-12 receipt">
          <div class="scheduled-confirmation">
            <div class="cancelled-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M18 6L6 18M6 6l12 12"></path>
              </svg>
            </div>
            <h1>Link expired</h1>
            <p>Your link has expired, please reach out to your broker.</p>
          </div>
        </div>
      </div>
    </div>
  </kendo-dialog>


<kendo-dialog
    class="speedbump"
    title="Merchant verification"
    *ngIf="showSpeedbump"
  >
    <div class="container">
      <div class="row">
        <div class="col-12">
          <p>Please verify this is the merchant you would like to pay.</p>
          <div class="d-flex justify-content-center">
            <img
              class="align-self-center logo"
              src="data:image/png;base64, {{ session?.merchant?.logo }}"
              alt="{{ session?.merchant?.name?.company }}"
            />
          </div>

          <form [formGroup]="pinForm">
            <div *ngIf="!showVerifyPin">
              <app-input-field
                [handleTranslate]="translate"
                [handleTextBlur]="pinBlur"
                [fieldConfig]="
                  Object.assign(getFieldConfig('email'), {
                    required: true,
                    readOnly: false,
                  })
                "
                fieldName="email"
                formControlName="email"
              ></app-input-field>

              <hr />

              <div class="d-flex">
                <button
                  kendoButton
                  size="large"
                  themeColor="primary"
                  class="flex-grow-1"
                  type="button"
                  [disabled]="!this.pinForm.valid || loading"
                  (click)="speedbumpVerify()"
                >
                  <kendo-loader
                    *ngIf="loading"
                    type="infinite-spinner"
                    size="small"
                    themeColor="dark"
                    class="edit-loader"
                  />
                  Send verification pin
                </button>
              </div>
            </div>
            <div *ngIf="showVerifyPin">
              <app-input-field
                [handleTranslate]="verifyPinTranslate"
                [handleTextBlur]="pinBlur"
                [fieldConfig]="{
                  en: 'Enter pin',
                  fr: 'Enter pin',
                  required: true,
                  readOnly: false,
                }"
                fieldName="pin"
                formControlName="pin"
              ></app-input-field>

              <hr />

              <div class="d-flex">
                <button
                  kendoButton
                  size="large"
                  themeColor="primary"
                  class="flex-grow-1"
                  type="button"
                  [disabled]="!this.pinForm.valid || loading"
                  (click)="pinVerify()"
                >
                  <kendo-loader
                    *ngIf="loading"
                    type="infinite-spinner"
                    size="small"
                    themeColor="dark"
                    class="edit-loader"
                  />
                  Click to agree
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </kendo-dialog>
  <div class="notification-container" #notificationContainer></div>
</div>
